import { DateTime } from 'luxon';

// https://moment.github.io/luxon/#/formatting?id=table-of-tokens
export enum DateFormat {
  short = 'MM/dd/yyyy', // 12/25/2022
  isoDate = 'yyyy-MM-dd', // 2024-01-23
  long = 'LLL dd, yyyy', // Aug 06, 2022
  hugeDate = 'ccc LLL dd, yyyy', // Wed Aug 06, 2022
  shortDateTime = 'MM/dd/yyyy @ hh:mm a', // 12/25/2022 # 01:07 EST
  shortDateTimeAt = "MM/dd/yyyy 'at' hh:mm a", // 12/25/2022 # 01:07 EST
  longDateTime = 'LLL dd, yyyy hh:mm a ZZZZ', // Aug 06, 2022 01:07 AM EST
  hugeDateTime = 'ccc LLL dd, yyyy hh:mm a ZZZZ', // Wed Aug 06, 2022 01:07 AM EST
  atShortDateTime = 'MM/dd/yy @ hh:mma', // 12/25/22 @ 04:07AM
  hugeTime = 'ttt', // 1:07:04 PM EDT
  smallTime = 't', // 9:07 a.m.
  year = 'yyyy', // 2022
}

export const getDateString = (
  format: DateFormat | string,
  date?: string | Date | null,
  convertToLocalTimeZone?: boolean
): string => {
  if (date) {
    if (typeof date === 'string') {
      return convertToLocalTimeZone
        ? DateTime.fromISO(date, { zone: 'utc' }).toLocal().toFormat(format)
        : DateTime.fromISO(date).toFormat(format);
    } else {
      return DateTime.fromJSDate(date).toFormat(format);
    }
  } else {
    return '';
  }
};

export const convertTimeFromISO = (closingTime: string, inputFormat?: string) => {
  return DateTime.fromFormat(closingTime, inputFormat ? inputFormat : 'HH:mm').toFormat('h:mm a');
};

export const getTimeAsISO = (value: string, suppressSeconds?: boolean): string | null => {
  let hour = Number(value.split(':')[0]);
  let minute = Number(value.split(':')[1].split(' ')[0]);
  const dayTime = value.split(':')[1].split(' ')[1].toLowerCase();
  if (dayTime === 'pm' && hour < 12) {
    hour = hour + 12;
  } else if (hour > 12) {
    hour = 12;
  } else if (minute > 59) {
    minute = 59;
  }
  return DateTime.utc(1, 1, 1, hour, minute).toISOTime({
    includeOffset: false,
    suppressMilliseconds: true,
    suppressSeconds: suppressSeconds,
  });
};

export const getISODateTime = (dataIso?: string | null): string | undefined | null =>
  dataIso ? DateTime.fromISO(dataIso).toISO({ includeOffset: true }) : dataIso;

export const getMillisFromDateAndTime = (date: string, time: string | undefined, timezone: string | undefined) => {
  const dateTime = time ? `${date}T${time}` : date;
  const dt = timezone ? DateTime.fromISO(dateTime, { zone: timezone }) : DateTime.fromISO(dateTime);
  if (!dt.isValid) {
    throw Error(`Invalid date ${date}, time ${time} or zone ${timezone} ` + dt.invalidReason);
  }
  return dt.toMillis();
};
